import React, { useState, useEffect } from "react";
import "./inputForm.css";
import { Button, Form, Input, Spin, message } from "antd";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 7,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 14,
        },
    },
};

// переменные для отправки почты, взятые из виртуального окружения
const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;

export default function InputForm(props) {
    const [loading, setLoading] = useState(false); // переменная показа состояния сплина
    const { t } = useTranslation(); // переменная для перевода
    const [form] = Form.useForm();

    const [queryForm, setQueryForm] = useState({
        // форма для отправки
        name: "",
        phone: "",
        city: "",
        message: "",
    });
    const [messageApi, contextHolder] = message.useMessage();

    // функция разрешения передачи формы и проверки наличия всех заполненных полей
    const [submittable, setSubmittable] = React.useState(false);
    const values = Form.useWatch([], form);
    useEffect(() => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => setSubmittable(true))
            .catch(() => setSubmittable(false));
    }, [form, values]);

    // функция показа сообщений успешной отправки формы и ошибки отправки формы
    const successMessage = () => {
        messageApi.open({
            type: "success",
            content: t("form_message_success"),
        });
    };
    const errorMessage = () => {
        messageApi.open({
            type: "error",
            content: t("form_message_error"),
        });
    };

    // функция отправки формы на почту
    const sendEmail = () => {
        setLoading(true);
        emailjs
            .send(SERVICE_ID, TEMPLATE_ID, queryForm, {
                publicKey: PUBLIC_KEY,
            })
            .then(
                () => {
                    successMessage();
                    setLoading(false);
                    setTimeout(() => props.closeModal(), 2000);
                },
                (error) => {
                    errorMessage(error);
                    setLoading(false);
                }
            );
    };

    // ввод данных для формы
    const inputForm = (e) => {
        const tempName = e.target.name;
        switch (tempName) {
            case "name":
                setQueryForm((prev) => {
                    return {
                        ...prev,
                        name: e.target.value,
                    };
                });
                break;
            case "phone":
                setQueryForm((prev) => {
                    return {
                        ...prev,
                        phone: e.target.value,
                    };
                });
                break;
            case "city":
                setQueryForm((prev) => {
                    return {
                        ...prev,
                        city: e.target.value,
                    };
                });
                break;
            case "message":
                setQueryForm((prev) => {
                    return {
                        ...prev,
                        message: e.target.value,
                    };
                });
                break;
            default:
                break;
        }
    };

    return (
        <>
            {" "}
            {contextHolder}
            <Form
                onFinish={sendEmail}
                {...formItemLayout}
                form={form}
                variant="outlined"
                autoComplete="off"
                name="validateOnly"
                size="large"
                style={{
                    maxWidth: 600,
                }}
            >
                <Form.Item
                    label={t("form_name")}
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: t("form_warning_message"),
                        },
                    ]}
                >
                    <Input name="name" onChange={(e) => inputForm(e)} />
                </Form.Item>
                <Form.Item
                    label={t("form_phone")}
                    name="phone"
                    rules={[
                        {
                            required: true,
                            message: t("form_warning_message"),
                        },
                    ]}
                >
                    <Input name="phone" onChange={(e) => inputForm(e)} />
                </Form.Item>
                <Form.Item
                    label={t("form_city")}
                    name="city"
                    rules={[
                        {
                            required: true,
                            message: t("form_warning_message"),
                        },
                    ]}
                >
                    <Input name="city" onChange={(e) => inputForm(e)} />
                </Form.Item>

                <Form.Item
                    label={t("form_message")}
                    name="message"
                    rules={[
                        {
                            required: true,
                            message: t("form_warning_message"),
                        },
                    ]}
                >
                    <Input.TextArea
                        name="message"
                        onChange={(e) => inputForm(e)}
                    />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 6,
                        span: 16,
                    }}
                >
                    {loading ? (
                        <div className="form__spin">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={!submittable}
                            size="middle"
                            onClick={() => sendEmail()}
                        >
                            {t("form_btn_submit")}
                        </Button>
                    )}
                </Form.Item>
            </Form>
        </>
    );
}
